export class AttachmentModel {
    url:string = '';
    lastModified:string = '';
    fileName:string = '';

    constructor(a?:Partial<AttachmentModel>) {
        Object.assign(this, a)   
    }
}
